export const fetchRosterData = async (teamAbbrev, season) => {
    const response = await fetch(`https://fla-game-schedule-worker.soapcreativeservices.workers.dev/roster/${teamAbbrev}/${season}`);
    if (!response.ok) {
        throw new Error('Failed to fetch roster data');
    }
    const data = await response.json();
    return data;
};
